export const IMG_FIRM_COVER_CFG = 'IMG_FIRM_COVER_CFG'
export const IMG_FIRM_LOGO_CFG = 'IMG_FIRM_LOGO_CFG'
export const IMG_FIRM_PICTURE_CFG = 'IMG_FIRM_PICTURE_CFG'
